import React, { Component } from "react";
import AppDynamicFilterModal from "../../../partials/AppDynamicFilterModal";

export class DupeCheckSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: {
        limit: 10,
        page: 1,
      },
      openDrawer: false,
    };
    this.fields = [
      {
        name: "customerName",
        label: "Name",
        type: "text",
        placeholder: "Customer Name",
      },
      {
        name: "mobileNumber",
        label: "Phone No.",
        type: "number",
        placeholder: "Phone No.",
      },
      {
        name: "panCardId",
        label: "PAN No.",
        type: "text",
        placeholder: "PAN No.",
      },
      {
        name: "loanAccountNumber",
        label: "Loan Account No",
        placeholder: "Loan Account No",
        type: "text",
      },
    ];
  }

  toggleDrawer = () => {
    this.setState((prev) => ({ openDrawer: !prev.openDrawer }));
  };

  closeDrawer = () => {
    this.setState({ openDrawer: false });
  };

  onSearch = (formData) => {
    let data = Object.filter(formData, (val) => val);
    this.props.onSearch && this.props.onSearch(data, false);
  };

  onReset = (formData, reset) => {
    let data = Object.filter(formData, (val) => val);
    this.props.onSearch && this.props.onSearch(data, reset);
  };

  render() {
    let { openDrawer } = this.state;
    return (
      <div className="d-flex align-items-center justify-content-end">
        <button
          type="button"
          className="btn filter_modal_btn"
          onClick={(...args) => this.toggleDrawer(...args)}
        >
          <i class="fa-solid fa-filter me-2"></i>
          <span>Filters</span>
        </button>
        <AppDynamicFilterModal
          open={openDrawer}
          onClose={this.closeDrawer}
          fields={this.fields}
          onSearch={this.onSearch}
          onReset={this.onReset}
        />
      </div>
    );
  }
}

export default constore(DupeCheckSearch);
